import { IClientStorage } from '@lingvo-news/contracts';

/**
 * Browser localStorage implementation of IClientStorage
 */
export class ClientStorage implements IClientStorage {
	get<T = string>(key: string): T | null {
		try {
			const value = localStorage.getItem(key);
			if (value===null) {
				return null;
			}

			// Try to parse as JSON
			try {
				return JSON.parse(value) as T;
			} catch {
				// If not JSON, return as string (cast to T)
				return value as unknown as T;
			}
		} catch (error) {
			console.error(`Error getting value from storage for key "${key}":`, error);
			return null;
		}
	}

	set<T = string>(key: string, value: T): void {
		try {
			const stringValue = JSON.stringify(value);
			localStorage.setItem(key, stringValue);
		} catch (error) {
			console.error(`Error setting value in storage for key "${key}":`, error);
		}
	}

	remove(key: string): void {
		try {
			localStorage.removeItem(key);
		} catch (error) {
			console.error(`Error removing value from storage for key "${key}":`, error);
		}
	}

	clear(): void {
		try {
			localStorage.clear();
		} catch (error) {
			console.error('Error clearing storage:', error);
		}
	}

	has(key: string): boolean {
		try {
			return localStorage.getItem(key)!==null;
		} catch (error) {
			console.error(`Error checking if key exists in storage for key "${key}":`, error);
			return false;
		}
	}
}








